import { makeAutoObservable, observable, computed, toJS} from "mobx"
import { MAP_QUERY_DEFAULTS, USER_CONFIG_DEFAULTS } from "./appConstants"
import { defaultQuery, reduceQuery, definedLayers } from "./queryManager"
import {
    boundsToPoly,
    polyToBounds,
    polyToArea,
    formatLatLngBounds
} from "../../utils/helpers/formatters"
class MapStore {
    featureConfig = USER_CONFIG_DEFAULTS.FEATURES
    initQuery = defaultQuery()
    tempQuery = defaultQuery()
    lastQuery = null
    autoUpdate = false
    mapRef = null
    zoom = MAP_QUERY_DEFAULTS.ZOOM
    center = MAP_QUERY_DEFAULTS.CENTER
    defaultBounds = MAP_QUERY_DEFAULTS.COORDINATES
    bounds = MAP_QUERY_DEFAULTS.COORDINATES
    resultsCollection = []
    resultsBounds = null
    ticketsInBound = []
    // layerCollection = definedLayers()
    currentLayers = []
    mapLoading = false
    canSearch = false
    singleResult = []
    searchMode = "MAP"
    drawnPoly = []
    drawEnabled = false
    constructor() {
        makeAutoObservable(this, {
            featureConfig: observable,
            initQuery: observable,
            tempQuery: observable,
            lastQuery: observable,
            autoUpdate: observable,
            defaultBounds: observable,
            resultsBounds: observable,
            zoom: observable,
            center: observable,
            bounds: observable,
            mapRef: observable,
            resultsCollection: observable,
            ticketsInBound: observable,
            // layerCollection: observable,
            currentLayers: observable,
            mapLoading: observable,
            canSearch: observable,
            singleResult: observable,
            searchMode: observable,
            drawnPoly: observable,
            getFeatureConfig: computed,
            getInitQuery: computed,
            getTempQuery: computed,
            getLastQuery: computed,
            getAutoUpdate: computed,
            getBounds: computed,
            getZoom: computed,
            getCenter: computed,
            getMapRef: computed,
            getResultsCollection: computed,
            getTicketsInBound: computed,
            getCurrentLayers: computed,
            getMapLoading: computed,
            getSingleResult: computed,
            getSearchMode: computed,
            getDrawnPoly: computed,
            getDrawEnabled: computed,

        })
    }

    setMapConfig(map){
        this.bounds = map.getBounds()
        this.zoom = map.getZoom()
        this.center = map.getCenter()
    }
    setInitQuery(override){
        this.initQuery = override
        this.tempQuery = override
    }
    setDrawnPoly(poly){
        this.drawnPoly = poly
    }
    setTempQuery(action){
        this.tempQuery = reduceQuery(this.getTempQuery, action)
    }
    setLastQuery(value){
        this.lastQuery = value
    }
    setAutoUpdate(toggle){
        this.autoUpdate = toggle
    }
    setZoom(zoom){
        this.zoom = zoom
        this.setTempQuery({ type: "ZOOM", data: zoom })
    }
    setCanSearch(area){ // pass area in
        this.canSearch = area < MAP_QUERY_DEFAULTS.MAXAREA
    }
    setCenter(center){
        this.center = center
        this.setTempQuery({ type: "CENTER", data: center })
    }
    setMapRef(mapRef){
        this.mapRef = mapRef
    }
    setBounds(bounds){ // {}
        this.bounds = bounds
    }
    setDefaultBounds(bounds){ // []
        let formatted = formatLatLngBounds(bounds)
        this.defaultBounds = formatted
    }
    setResultsBounds(bounds){ // []
        this.resultsBounds = bounds
    }
    setResultsCollection(results){
        this.resultsCollection = results
    }
    setTicketsInBound(ticketsInBound){
        this.ticketsInBound = ticketsInBound
    }
    setCurrentLayers(layers){
        this.currentLayers = layers
    }
    setMapLoading(mapLoading){
        this.mapLoading = mapLoading
    }
    setDrawEnabled(bool){
        this.drawEnabled = bool
    }
    setSingleResult(result){
        this.singleResult = result
    }
    setSearchMode(mode){
        this.searchMode = mode
    }
    get getFeatureConfig(){
        return toJS(this.featureConfig)
    }
    get getDrawnPoly(){
        return toJS(this.drawnPoly)
    }
    get getInitQuery(){
        return toJS(this.initQuery)
    }
    get getTempQuery(){
        return toJS(this.tempQuery)
    }
    get getLastQuery(){
        return toJS(this.lastQuery)
    }
    get getAutoUpdate(){
        return this.autoUpdate
    }
    get getBounds() { // {}
        return toJS(this.bounds)
    }
    get getDefaultBounds() { // []
        return toJS(this.defaultBounds)
    }
    get getResultsBounds() { // []
        return toJS(this.resultsBounds)
    }
    get getZoom() {
        return this.zoom
    }
    get getCanSearch(){
        return this.canSearch
    }
    get getCenter() {
        return this.center
    }
    get getMapRef(){
        return this.mapRef
    }
    get getResultsCollection(){
        return toJS(this.resultsCollection)
    }
    get getTicketsInBound(){
        return toJS(this.ticketsInBound)
    }
    // get getLayerCollection(){
    //     return toJS(this.layerCollection)
    // }
    get getCurrentLayers(){
        return toJS(this.currentLayers)
    }
    get getMapLoading(){
        return this.mapLoading
    }
    get getSingleResult(){
        return toJS(this.singleResult)
    }
    get getSearchMode(){
        return toJS(this.searchMode)
    }
    get getDrawEnabled(){
        return this.drawEnabled
    }
}


const mapStore = new MapStore()

export { mapStore }
